import React from 'react';
import classname from 'classnames';

import UItem from '../item';
import { BaseWidgetProps } from '../../utils/type';

export interface InputProps extends BaseWidgetProps {
  value: any;
  label?: string;
  align?: 'left' | 'center' | 'right';
  suffix?: string;
  prefix?: string;
}

// 表单 输入框组件
function UValue(props: InputProps) {
  const {
    value,
    prefixCls = 'crm-value-price',
    align,
    suffix,
    prefix,
    ...rest
  } = props;

  const cls = classname(prefixCls, {
    [`${prefixCls}-${align}`]: !!align,
  });
  const newValue = (value < 0) ? 0 : value;

  return (
    <UItem
      {...rest}
      itemType="valuePrice"
    >
      <div className={cls}>
        {prefix ? <span className={`${prefixCls}-prefix`}>{prefix}</span> : null}
        {newValue}
        {suffix ? <span className={`${prefixCls}-suffix`}>{suffix}</span> : null}
      </div>
    </UItem>
  );
}

export default UValue;
